module.exports = __webpack_public_path__ + "img/icon_star.257b4ea8.svg";